<div
    class="border-border bg-card flex cursor-pointer items-center justify-between rounded-xl border p-4 transition"
>
    <div class="flex flex-col gap-1">
        <p class="text-muted-foreground text-sm">{{ title }}</p>
        <p class="text-success text-2xl font-bold">{{ value }}</p>
    </div>

    <div
        class="flex h-10 w-10 items-center justify-center rounded-lg"
    >
        <mat-icon [svgIcon]="icon" [style.color]="color" class="text-success/20 h-8 w-8"></mat-icon>
    </div>
</div>
